module.exports = __webpack_public_path__ + "img/taili1.f8f79693.jpg";